// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2_JMQ","dragIcon":"SortableItem_dragIcon__31qTq","disabled":"SortableItem_disabled__D34Pw"};